var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMenu = function SvgMenu(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 25 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M2.5 6.5a4.75 4.75 0 1 1 9.5 0 4.75 4.75 0 0 1-9.5 0M13.5 17.5a4.75 4.75 0 1 1 9.5 0 4.75 4.75 0 0 1-9.5 0M23 6.5a4.75 4.75 0 1 0-9.5 0 4.75 4.75 0 0 0 9.5 0M12 17.5a4.75 4.75 0 1 0-9.5 0 4.75 4.75 0 0 0 9.5 0",
    clipRule: "evenodd"
  })));
};
export default SvgMenu;